export default __webpack_public_path__ + "static/media/line-seperator.png";